var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading_status"},[_c('div',{staticClass:"spinner"},[_c('h3',[_vm._v(_vm._s(_vm.text ? _vm.text : '暂无该资源'))])])])}
var staticRenderFns = []

export { render, staticRenderFns }